import React from 'react';
import { buildInfo } from '../config/runtime';
import { reportOperationalError } from '../utils/operationalErrors';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    reportOperationalError(error, {
      component: 'AppErrorBoundary',
      buildVersion: buildInfo.version,
    });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="flex min-h-screen items-center justify-center bg-stone-50 px-6">
        <div className="ds-surface w-full max-w-lg p-8 text-center">
          <h1 className="text-2xl font-semibold text-slate-900">The workspace needs to recover</h1>
          <p className="mt-3 text-sm text-slate-600">
            Your saved case data remains in the workspace. Reload the application; if the problem repeats, record the time and contact support.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-6 rounded-xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white"
          >
            Reload workspace
          </button>
        </div>
      </main>
    );
  }
}

export default AppErrorBoundary;
